import { useState, useEffect } from 'react'

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    // @ts-ignore
    const userAgent = navigator.userAgent || navigator.vendor || window.opera

    setIsMobile(/android|iphone|ipad|ipod|windows phone/i.test(userAgent))
  }, [])

  return isMobile
}
